import * as React from "react";

import { DevicesList } from "@/shared/components/devices";
import { CreateDeviceButton } from "@/shared/components/devices/CreateDevice";
import type { Condition } from "@/types";

import { useDeviceTypeContext } from "../DeviceType/useDeviceTypeContext";

import styles from "./DeviceTypeDevices.module.css";

/**
 * Devices tab of a device type: the devices grid, narrowed to the devices of
 * this type, with a New Device form that has the type preselected. An existing
 * device's type is changed from the device's page or the devices grid.
 */
export function DeviceTypeDevices() {
  const { deviceType } = useDeviceTypeContext();
  const conditions = React.useMemo<Condition[]>(
    () => [
      {
        field: "device_type_id",
        comparator: "EQUALS",
        value: deviceType.device_type_id,
      },
    ],
    [deviceType.device_type_id],
  );

  return (
    <div className={styles.table}>
      <DevicesList
        conditions={conditions}
        deviceTypeId={deviceType.device_type_id}
        actions={
          <CreateDeviceButton deviceTypeId={deviceType.device_type_id} />
        }
      />
    </div>
  );
}
